import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseResetPasswordComponent } from '../../../../../../coverpath-common/angular/components/login-container/reset-password/base-reset-password.component';
import { AmorphicService } from '../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { ValidationService } from '../../../../../../coverpath-common/angular/services/validation/validation.service';
import { LoginService } from '../../../services/login/login.service';
import { CoverpathUtils } from '../../../../../../coverpath-common/js/static/CoverpathUtils';
import { AuthenticatingController } from '../../../../../../common/js/AuthenticatingController';
import { Controller } from '../../../Controller';
import { AuthenticationService } from '../../../../../../coverpath-common/angular/services/authentication/authentication.service';

@Component({
  moduleId: module.id,
  selector: 'reset-password',
  templateUrl: './reset-password.component.html',
})
export class ResetPasswordComponent extends BaseResetPasswordComponent {
  constructor(
    private amorphicServiceInj: AmorphicService,
    private validationServiceInj: ValidationService,
    private loginServiceInj: LoginService,
    private routerInstance: Router,
    private routeInstance: ActivatedRoute,
    authService: AuthenticationService
  ) {
    super(amorphicServiceInj, validationServiceInj, loginServiceInj, routerInstance, routeInstance, authService);
  }

  ngOnInit(): void {
    this.finishReset = this.routeInstance.snapshot.queryParams['reset_password'] === 'true';
    this.resetButtonDisabled = this.controller.email ? false : true;
    this.finishResetButtonDisabled = true;
  }

  resetPassword(): void {
    if (!super.validateEmail()) {
      return;
    }

    this.loginServiceInj.resetPassword(document.location.href).then(() => {
      CoverpathUtils.dataLayerPush({
        event: 'gtm-event-client_forgot-password',
      });
      this.emailSent = true;
    });
  }

  async finishResetPassword(): Promise<void> {
    if (!super.validateFinishReset()) {
      return;
    }

    try {
      await this.loginServiceInj.finishResetPassword();

      CoverpathUtils.dataLayerPush({
        event: 'gtm-event-client_reset-password',
      });

      // Special case: password reset for legacy, non-AMC user
      // Need to use legacy logout even though Auth0 is enabled
      if (this.isAuth0Enabled()) {
        await this.legacyLogout();
        this.routerInstance.navigate(['home']);
      } else {
        this.routerInstance.navigate(['account-center']);
      }
    } catch (error) {
      this.errorMessage = 'Error resetting password';
    }
  }

  private isAuth0Enabled(): boolean {
    const controller: AuthenticatingController = this.controller as unknown as AuthenticatingController;
    return controller.isAuth0Enabled;
  }

  private async legacyLogout(): Promise<void> {
    const controller: Controller = this.controller as unknown as Controller;
    await controller.serverLogout();
  }
}
